import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CenterBox, LeftBox } from "./commons/BoxAbstraction";
import ImageCarousel from "./Carousel";
import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ProductCard = ({ data, GAEventsTracker }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const previewDialog = () => {
    return (
      <Dialog
        sx={{ "& .MuiDialog-paper": { margin: "16px" } }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle fontSize={"16px"}>
          {data.title1 + " " + data.title2 + " PDF Preview"}{" "}
        </DialogTitle>
        <DialogContent>
          <img
            src={data.picture}
            alt={data.title1}
            style={{ maxHeight: "100%", maxWidth: "100%", padding: "8px" }}
          />
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <Box
      sx={{
        ...data.styles,
        width: isSmallScreen ? "120px" : "265px",
        height: isSmallScreen ? "280px" : "550px",
        background: "#022674",
        borderRadius: isSmallScreen ? "10px" : "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0px 4px 4px 2px rgba(0,0,0,0.25)",
      }}
    >
      <Box sx={{ order: data.title1 === "Total" ? 2 : 0 }}>
        <Typography
          sx={{ color: "#fff" }}
          variant={isSmallScreen ? "h3Mobile" : "h3"}
        >
          <span
            style={{
              color: "#7BB58C",
              display:
                data.title1 === "Personal" || data.title1 === "Total"
                  ? ""
                  : "block",
            }}
          >
            {" "}
            {data.title1}
          </span>{" "}
          {data.title2}
        </Typography>
        <Typography
          mt={1}
          variant={isSmallScreen ? "body2Mobile" : "body2"}
          sx={{ color: "#fff" }}
        >
          {data.description}
        </Typography>
      </Box>
      {/* preview button*/}

      <Stack direction="row" alignItems="center" gap={2}>
        {data?.previewImages?.length || data?.picture ? (
          <Button
            variant={isSmallScreen ? "mobile" : "contained"}
            sx={{
              padding: isSmallScreen ? "3px 3px 3px 6px" : "3px 3px 3px 12px ",
              background: "#7BB58C",
              borderRadius: "12px",
              textTransform: "none",
            }}
            onClick={() => {
              GAEventsTracker(
                `${data.title1} ${data.title2} Preview Viewed`,
                "successfully"
              );
              setOpen(true);
            }}
          >
            <LeftBox gap={isSmallScreen ? "6px" : "12px"}>
              <Typography
                sx={{ color: "#fff", fontSize: isSmallScreen ? "10px" : "" }}
              >
                Preview
              </Typography>
              <CenterBox
                sx={{
                  width: isSmallScreen ? "24px" : "35px",
                  height: isSmallScreen ? "16px" : "25px",
                  background: "#fff",
                  borderRadius: "12px",
                }}
              >
                <VisibilityIcon
                  sx={{
                    color: "#4C4C4C",
                    fontSize: isSmallScreen ? "16px" : "24px",
                  }}
                />
              </CenterBox>
            </LeftBox>
          </Button>
        ) : (
          ""
        )}
        {/* {previewDialog()} */}
        {data.previewImages?.length ? (
          <ImageCarousel
            open={open}
            title={`${data.title1} ${data.title2}`}
            onClose={handleClose}
            images={data.previewImages}
          />
        ) : data.picture ? (
          previewDialog()
        ) : (
          ""
        )}
      </Stack>
      <Box
        sx={{
          order: data.title1 === "Total" || data.title1 === "Language" ? -2 : 0,
          paddingTop:
            data.title1 === "Language" ? (isSmallScreen ? "30px" : "65px") : "",
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          alt="report-types"
          src={`/images/${data.image}`}
          sx={{ width: isSmallScreen ? "90%" : "100%" }}
        />
      </Box>
    </Box>
  );
};

export default ProductCard;
